export const menuGroups = [
    {
        title: 'Omgevingsvisie',
        to: '/omgevingsvisie',
        items: [
            {
                text: 'Ambities',
                to: '/omgevingsvisie/ambities',
            },
            {
                text: 'Beleidsdoelen',
                to: '/omgevingsvisie/beleidsdoelen',
            },
            {
                text: 'Beleidskeuzes',
                to: '/omgevingsvisie/beleidskeuzes',
            },
        ],
    },
    {
        title: 'Omgevingsprogramma',
        to: '/omgevingsprogramma',
        items: [
            {
                text: 'Verplichte programma’s',
                to: '/omgevingsprogramma/verplichte-programmas',
            },
            {
                text: 'Thematische programma’s',
                to: '/omgevingsprogramma/thematische-programmas',
            },
            {
                text: 'Gebiedsprogramma’s',
                to: '/omgevingsprogramma/gebiedsprogrammas',
            },
            {
                text: 'Maatregelen',
                to: '/omgevingsprogramma/maatregelen',
            },
        ],
    },
    {
        title: 'Omgevingsverordening',
        items: [
            {
                text: 'Verordening',
                to: 'https://www.zuid-holland.nl/onderwerpen/omgevingsbeleid/zuid-hollandse-omgevingsverordening/',
                targetBlank: true,
            },
        ],
    },
    {
        title: 'Actueel',
        items: [
            {
                text: 'Herzieningen',
                to: '/herzieningen',
            },
            {
                text: 'Lange termijn agenda',
                to: 'https://lta.zuid-holland.nl/',
                targetBlank: true,
            },
        ],
    },
    {
        title: 'Overig Omgevingsbeleid',
        items: [
            // {
            //     text: 'Beleidsregels',
            //     to: '/omgevingsverordening/beleidsregels',
            // },
            {
                text: 'Beleidsnetwerk',
                to: '/beleidsnetwerk',
            },
        ],
    },
]
